import { type PropsWithChildren, type ReactNode } from 'react';

type SmartAbbrProps = PropsWithChildren<{
  title?: string;
}>;

/**
 * Function to handle abbreviation of text and dosen't translate the text.
 *
 * @param param0 props
 * @param param0.children The text to be displayed
 * @param param0.title The title of the text
 * @returns The text with abbreviation if needed
 */
export function SmartAbbr({ children, title }: SmartAbbrProps): ReactNode {
  if (!children && !title) {
    return undefined;
  }
  if (children === title || !title) {
    return (
      <span className="whitespace-nowrap" translate="no">
        {children}
      </span>
    );
  }
  return (
    <abbr title={title} translate="no" className="whitespace-nowrap">
      {children}
    </abbr>
  );
}
